/* ============================================================== */
/*                                                                */
/*   ExamV4 กติกา UI ที่ pure  ·  HIS V4 · หน้าตรวจรักษา             */
/*                                                                */
/*   team practice (ดู common/sequence/PatientOrdersV4.ts +           */
/*   patient/CardOrdersV4.tsx:137-162):                              */
/*     card เรียก props.runSequence({ sequence, action, card, ... })   */
/*     sequence เป็นคนตัดสินใจเรียก API + เขียน state                 */
/*   ไฟล์นี้จึงไม่มี issara-sdk และไม่มี helper ประกอบ event เอง        */
/*                                                                */
/*   ACTIONS / SEQUENCE_NAME / BTN_ACTS / RunSequence type            */
/*   อยู่ที่ common/sequence/ExamV4.ts (source of truth เดียว)        */
/*   slice + mapper อยู่ที่ patient/examModelV4.ts                    */
/*                                                                */
/*   ส่วนที่เหลือคือ gate ของ UI ที่ test ได้โดยไม่เรียก API           */
/*                                                                */
/* ============================================================== */

/**
 * card ที่เป็นผู้ส่ง action ของ ExamV4
 * ค่านี้ถูกส่งใน params.card แล้ว sequence ใช้เป็น key ของ
 * state.buttonLoadCheck["<card>_<ACTION>"] และ state.errorMessage["<card>"]
 * (format เดียวกับ HISV3/common/CommonInterface.ts:SetErrorMessage)
 */
export const CARD_NAMES = {
  doctor: "CardDoctorV4",
  gallery: "CardGalleryV4",
  nursing: "CardNursingV4",
  /** flag ของ Patient Panel (ประวัติแพ้ / โรคประจำตัว) — sequence เดียวกัน (ExamV4) แต่คนละ card key */
  flags: "CardPatientFlagV4",
  /** ระดับสมาชิก + นัดครั้งหน้า ของ Patient Panel */
  panel: "PatientPanelV4",
} as const;

/** action ของ EnterExam ที่ V3 ใช้ตอนยกเลิก checkout (CardPatientListInterface.ts:1919-1935) */
export const ACTION_START_EXAM = "OPD_QUEUE_EXAM";

/**
 * สถานะที่ผู้ป่วย "ยังไม่ได้เข้าห้องตรวจ" ต้องเรียกเข้าตรวจก่อน
 * copy จาก QUEUE_STAGES ขั้น wait-doctor (common/sequence/PatientListV4.ts:96-102)
 * ถ้า queue เปลี่ยน stage ต้องแก้ตรงนี้ด้วย
 */
export const CALL_IN_STATUSES = ["SCREENED", "IN_QUEUE", "RECEIVE_RESULT"];

/** สถานะที่ checkout แล้วแต่หมอขอเปิดตรวจต่อ (V3 CHECKED_OUT:CANCEL_CHECKOUT) */
export const CHECKED_OUT_STATUSES = ["CHECKED_OUT", "OPD_CHECK_OUT", "CANCEL_CHECKOUT"];

export const isCallInStatus = (status: string | null | undefined): boolean =>
  typeof status === "string" && CALL_IN_STATUSES.indexOf(status) !== -1;

export const isCheckedOutStatus = (status: string | null | undefined): boolean =>
  typeof status === "string" && CHECKED_OUT_STATUSES.indexOf(status) !== -1;

/**
 * V3 gate การเรียกเข้าตรวจด้วยบทบาท (state.django.user.role_types.includes("DOCTOR")
 *   HISV3/common/CardPatientListInterface.ts:854) ไม่ได้ gate ด้วย allowed_actions
 */
export const DOCTOR_ROLE = "DOCTOR";

export const isDoctorRole = (roleTypes?: string[] | null): boolean =>
  Array.isArray(roleTypes) && roleTypes.indexOf(DOCTOR_ROLE) !== -1;
